



$(function () {
    createAccordionArea(chara_list, accordion_month);
    createCharaLink(chara_list);
    createOverviewAnime(chara_list);

    // タイトルをクリックすると
    $(".js-accordion-title").on("click", function () {
        // クリックした次の要素を開閉
        $(this).next().slideToggle(300);
        // タイトルにopenクラスを付け外しして矢印の向きを変更
        $(this).toggleClass("open", 300);
    });
});

function createAccordionArea(chara_list, accordion_month) {
    $.each(accordion_month, function (index) {
        $('.accordion-container').append('\
            <div class="accordion-item">\
            <div class="accordion-title js-accordion-title font__small">\
                <span class="accordion_chara accordion_chara_'+ accordion_month[index] + '">' + accordion_month[index] + '月</span>\
                <span class="accordion_chara_img_'+ accordion_month[index] + '"></spna>\
            </div>\
            <div class="accordion-content">\
                <div class="accordion-content-child month_list_'+ accordion_month[index] + '"></div>\
            </div>\
        </div>\
        ')
    });
    // 販売終了があったら販売終了アコーディオンも作る
    var soldout_list = chara_list.filter(value => {
        return value[14] === 2;
    })
    if (soldout_list.length > 0) {
        $('.accordion-container').append('\
            <div class="accordion-item">\
            <div class="accordion-title js-accordion-title font__small">\
                <span class="accordion_chara">終了<span>\
            </div>\
            <div class="accordion-content">\
                <div class="accordion-content-child soldout_list"></div>\
            </div>\
        </div>\
        ')
    }

}


function createCharaLink(chara_list) {
    //  キャラクターの数だけ要素を作る
    $.each(chara_list, function (index) {
        // 販売中
        if (chara_list[index][14] === 0) {
            if(chara_list[index][6]!= ""){
                $('.product_list').append('\
                        <div class="product_child font__small">\
                            <p class="chara_name font__bold font__middle" style="background:linear-gradient(transparent 80%, '+ chara_list[index][11] + ' 0%);">' + chara_list[index][1] + '</p>\
                            <div class="product_child_top">\
                                <div class="product_img"><img src="'+ chara_list[index][7]+'"></div>\
                                <div class="product_text">\
                                    <p><span class="product_text_title font__bold">受付期間</span>'+ chara_list[index][3] + '〜<br>' + chara_list[index][4] + '</p>\
                                    <p><span class="product_text_title font__bold">お届け時期</span>'+ chara_list[index][2] + '</p>\
                                </div>\
                            </div>\
                                <div class="product_child_bottom">\
                                    <a class="product_btn font__bold" href="'+ chara_list[index][5] + '">１回目<br><span class="font__xsmall font__normal">はじめて贈る方向け</span></a>\
                                    <a class="product_btn font__bold" href="'+ chara_list[index][6] + '">２回目<br><span class="font__xsmall font__normal">昨年も贈った方向け</span></a>\
                                </div>\
                                <div class="product_attention">\
                                    <p>※どちらも全てのお客様にご予約いただけます<br>\
                                    ※ご予約ページが異なりますので、お間違えないようお願いいたします</p>\
                                </div>\
                        </div>');
            } else if(chara_list[index][6] == "") {
                 $('.product_list').append('\
                        <div class="product_child font__small">\
                            <p class="chara_name font__bold font__middle" style="background:linear-gradient(transparent 80%, '+ chara_list[index][11] + ' 0%);">' + chara_list[index][1] + '</p>\
                            <div class="product_child_top">\
                                <div class="product_img"><img src="'+ chara_list[index][7]+'"></div>\
                                <div class="product_text">\
                                    <p><span class="product_text_title font__bold">受付期間</span>'+ chara_list[index][3] + '〜<br>' + chara_list[index][4] + '</p>\
                                    <p><span class="product_text_title font__bold">お届け時期</span>'+ chara_list[index][2] + '</p>\
                                </div>\
                            </div>\
                                <div class="product_child_bottom">\
                                    <a class="product_btn font__bold" href="'+ chara_list[index][5] + '">１回目<br><span class="font__xsmall font__normal">はじめて贈る方向け</span></a>\
                                </div>\
                                <div class="product_attention">\
                                    <p>※どちらも全てのお客様にご予約いただけます<br>\
                                    ※ご予約ページが異なりますので、お間違えないようお願いいたします</p>\
                                </div>\
                        </div>');
            }
        } else if (chara_list[index][14] === 2) {
            // 販売終了
            $('.soldout_list').append('\
                    <div class="product_child font__small">\
                    <p class="chara_name font__bold font__middle" style="background:linear-gradient(transparent 80%, '+ chara_list[index][11] + ' 0%);">' + chara_list[index][1] + '</p>\
                    <div class="product_child_top">\
                        <div class="product_img"><img src="'+ chara_list[index][7] + '"></div>\
                            <div class="product_text">\
                                <p><span class="product_text_title font__bold">受付期間</span>'+ chara_list[index][3] + '〜<br>' + chara_list[index][4] + '</p>\
                                <p><span class="product_text_title font__bold">お届け時期</span>'+ chara_list[index][2] + '</p>\
                            </div>\
                        </div>\
                    </div>');
        } else if (chara_list[index][14] === 1) {
            // comming soon
            var is_exist = accordion_month.includes(chara_list[index][13]);
            if (is_exist === true) {
                $('.accordion_chara_img_' + chara_list[index][13]).append('\
                    <img class="accordion_chara_img" src="'+ chara_list[index][12] + '">\
                ');
                $('.month_list_' + chara_list[index][13]).append('\
                        <div class="product_child font__small">\
                            <p class="chara_name font__bold font__middle" style="background:linear-gradient(transparent 80%, '+ chara_list[index][11] + ' 0%);">' + chara_list[index][1] + '</p>\
                            <div class="product_child_top">\
                                <div class="product_img"><img src="'+ chara_list[index][8] + '"></div>\
                                <div class="product_text">\
                                    <p><span class="product_text_title font__bold">受付期間</span>'+ chara_list[index][3] + '〜<br>' + chara_list[index][4] + '</p>\
                                    <p><span class="product_text_title font__bold">お届け時期</span>coming soon</p>\
                                </div>\
                            </div>\
                        </div>');
            } else if (is_exist === false) {
                $('.product_list').append('\
                    <div class="product_child font__small">\
                        <p class="chara_name font__bold font__middle" style="background:linear-gradient(transparent 80%, '+ chara_list[index][11] + ' 0%);">' + chara_list[index][1] + '</p>\
                        <div class="product_child_top">\
                            <div class="product_img"><img src="'+ chara_list[index][8] + '"></div>\
                            <div class="product_text">\
                                <p><span class="product_text_title font__bold">受付期間</span>'+ chara_list[index][3] + '〜<br>' + chara_list[index][4] + '</p>\
                                <p><span class="product_text_title font__bold">お届け時期</span>coming soon</p>\
                            </div>\
                        </div>\
                    </div>');
            }
        }
    });
}

function createOverviewAnime(param_chara_list) {
    var sale_list = getSaleList(param_chara_list);
    if (sale_list.length == 0) {
        $('.anime1').append('<img class="overview_img_child" src="' + chara_list[0][9] + '">')
        $('.anime2').append('<img class="overview_img_child" src="' + chara_list[0][10] + '">')
    } else if (sale_list.length == 1) {
        $('.anime1').append('<img class="overview_img_child" src="' + param_chara_list[sale_list[0]][9] + '">')
        $('.anime2').append('<img class="overview_img_child" src="' + param_chara_list[sale_list[0]][10] + '">')
    } else {
        $.each(sale_list, function (index) {
            $('.anime1').append('<img class="overview_img_child" src="' + param_chara_list[sale_list[index]][9] + '">')
            $('.anime2').append('<img class="overview_img_child" src="' + param_chara_list[sale_list[index]][10] + '">')
        });
        $(".anime").slick({
            autoplay: true,
            autoplaySpeed: 1500,
            speed: 400,
            fade: true,
            arrows: false,
            speed: 1000
        });
    }
}

function getSaleList(param_chara_list) {
    const sale_list = [];
    $.each(param_chara_list, function (index) {
        if (param_chara_list[index][14] == 0) {
            sale_list.push(index);
        }
    });
    return sale_list;
}

